/**
 * Firebase Configuration
 * Uses the same Firebase project as the mobile app
 */

import { initializeApp, getApps, FirebaseApp } from "firebase/app";
import { getAuth, Auth } from "firebase/auth";
import { GoogleAuthProvider, FacebookAuthProvider } from "firebase/auth";

// Firebase config from mobile app (web configuration)
const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY || "AIzaSyDjWoJyuM7spiXhguq8TwJyXsPB9pfngMY",
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN || "gritizer-65042.firebaseapp.com",
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID || "gritizer-65042",
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET || "gritizer-65042.firebasestorage.app",
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID || "352616333705",
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID || "1:352616333705:web:0f1c6fd3a15bc4d28ca158",
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID || "G-6K32RK8LNM",
};

// Initialize Firebase (singleton pattern) - only on client side
function initializeFirebase() {
  if (typeof window === "undefined") {
    throw new Error("Firebase can only be initialized on the client side");
  }

  if (getApps().length === 0) {
    return initializeApp(firebaseConfig);
  }
  return getApps()[0];
}

// Lazy initialization - only when needed
let app: FirebaseApp | undefined;
let authInstance: Auth | undefined;
let googleProviderInstance: GoogleAuthProvider | undefined;
let facebookProviderInstance: FacebookAuthProvider | undefined;

export function getApp(): FirebaseApp {
  if (!app) {
    app = initializeFirebase();
  }
  return app;
}

export function getAuthInstance(): Auth {
  if (typeof window === "undefined") {
    throw new Error("Firebase Auth can only be used on the client side");
  }
  
  if (!authInstance) {
    authInstance = getAuth(getApp());
  }
  return authInstance;
}

export function getGoogleProvider(): GoogleAuthProvider {
  if (!googleProviderInstance) {
    googleProviderInstance = new GoogleAuthProvider();
    googleProviderInstance.addScope("profile");
    googleProviderInstance.addScope("email");
  }
  return googleProviderInstance;
}

export function getFacebookProvider(): FacebookAuthProvider {
  if (!facebookProviderInstance) {
    facebookProviderInstance = new FacebookAuthProvider();
    facebookProviderInstance.addScope("email");
    facebookProviderInstance.addScope("public_profile");
  }
  return facebookProviderInstance;
}

// Export getters as the main exports
export const auth = getAuthInstance;
export const googleProvider = getGoogleProvider;
export const facebookProvider = getFacebookProvider;
export { getApp as app };
export default getApp;
